import React from "react";
import "./NeedsCalculator.scss";
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../sessionStorage';
import { Container } from "react-bootstrap";

export default function NeedsAnalysisFooter(props) {

  var accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  var accountPhone = accountObj.account.phone

  return (
    <div className="justify-content-center need-analysis-footer">
      <Container>
        <p className="need-analysis-footer-text">
          The projected amount of new life insurance death benefit you may need to provide is based upon the information you have provided.
      </p>
        <p className="need-analysis-footer-text">
          This calculator is a planning tool designed to assist you in determining a possible life insurance need. The results and explanations generated by this calculator may vary due to your input and assumptions. Covr does not guarantee the accuracy of the calculations, results, explanations, nor applicability to your specific situation. All projections are hypothetical and it is recommended that you use this calculator as a guideline, only. For a more accurate and detailed analysis specific to your circumstances and needs, contact us at {accountPhone}
        </p>
      </Container>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Tools/NeedsAnalysis/NeedAnalysisFooter.js